import React, { useEffect, useState } from "react";

import { PieChart } from "../../../../../../components/molecules/Charts";
import { IAlertsStatistic } from "../../../../../../types";
import { useActionsHook, useTypedSelectorHook } from "../../../../../../utils";

/**
 * Вкладка алертов в течение дня раздела Alerts Analytics - Day *
 */

export const AlertsPerDay: React.FC = () => {
  const { alertsStatistic } = useTypedSelectorHook(({ alerts }) => alerts);
  const { getAlertsStatisticActions } = useActionsHook();
  const [alertsPerDay, setAlertsPerDay] = useState<IAlertsStatistic[]>([]);

  useEffect(() => {
    getAlertsStatisticActions("day");
  }, []);

  useEffect(() => {
    if (alertsStatistic) {
      setAlertsPerDay(
        alertsStatistic.map((item) => {
          return {
            ...item,
          };
        })
      );
    }
  }, [alertsStatistic]);

  return (
    <PieChart
      id="dashboardPieChart"
      value="value"
      category="category"
      data={
        alertsPerDay.length
          ? alertsPerDay
          : [
              {
                category: "Negligible",
                value: 2,
              },
              {
                category: "Major",
                value: 1,
              },
              {
                category: "Severe",
                value: 1,
              },
            ]
      }
      width={200}
    />
  );
};
